<template>
  <div class="lab-admin" v-loading="loading">
    <p class="lab-description">设置每个实验室项目的可见范围。没有可见项目时，顶部的“实验室”菜单会自动隐藏。</p>
    <div v-for="feature in features" :key="feature.key" class="lab-feature">
      <div class="feature-info">
        <i :class="feature.key === 'background' ? 'el-icon-picture-outline' : 'el-icon-s-data'"></i>
        <div><strong>{{ feature.title }}</strong><small>{{ feature.path }}</small></div>
      </div>
      <el-radio-group v-model="feature.visibility" size="small" :disabled="saving === feature.key" @change="save(feature)">
        <el-radio-button label="ALL">所有用户</el-radio-button>
        <el-radio-button label="ADMIN">仅管理员</el-radio-button>
        <el-radio-button label="HIDDEN">隐藏</el-radio-button>
      </el-radio-group>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { EventBus } from '@/EventBus'

export default {
  name: 'AdminLab',
  data() { return { features: [], loading: false, saving: '' } },
  created() { this.load() },
  methods: {
    headers() { return { Authorization: 'Bearer ' + localStorage.getItem('token') } },
    async load() {
      this.loading = true
      try {
        const response = await axios.get('/api/admin/lab/features', { headers: this.headers() })
        if (response.data.code !== 200) throw new Error(response.data.message)
        this.features = response.data.data
      } catch (error) { this.$message.error('实验室设置加载失败') }
      finally { this.loading = false }
    },
    async save(feature) {
      this.saving = feature.key
      try {
        const response = await axios.put(`/api/admin/lab/features/${feature.key}`,
          { visibility: feature.visibility }, { headers: this.headers() })
        if (response.data.code !== 200) throw new Error(response.data.message)
        Object.assign(feature, response.data.data)
        EventBus.$emit('labVisibilityChanged')
        this.$message.success('展示范围已更新')
      } catch (error) {
        this.$message.error('保存失败，请重试')
        await this.load()
      } finally { this.saving = '' }
    }
  }
}
</script>

<style scoped>
.lab-admin { min-height: 160px; }
.lab-description { margin: 0 0 18px; color: #7b8593; font-size: 13px; }
.lab-feature { display: flex; align-items: center; justify-content: space-between; flex-wrap: wrap; gap: 16px; padding: 18px; border: 1px solid rgba(220, 223, 230, .75); border-radius: 12px; background: rgba(255, 255, 255, .42); }
.feature-info { display: flex; align-items: center; gap: 12px; }
.feature-info i { display: grid; place-items: center; width: 38px; height: 38px; color: #409eff; border-radius: 10px; background: rgba(64, 158, 255, .12); font-size: 18px; }
.feature-info strong, .feature-info small { display: block; }
.feature-info strong { font-size: 15px; }
.feature-info small { margin-top: 3px; color: #909399; font-size: 12px; letter-spacing: normal; font-weight: 400; }
@media (max-width: 767px) { .lab-feature { align-items: flex-start; } .lab-feature >>> .el-radio-button__inner { padding: 9px 10px; } }
</style>
